module.exports = __webpack_public_path__ + "img/blog-transfer-gb-whatsapp-chats.96dcab71.png";